import React, { CSSProperties, FC } from "react";
import { BaseSvgProps } from "./types";

function HeroPre({
  color,
  style,
}: {
  color?: CSSProperties["color"];
  style: CSSProperties;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      x="0px"
      y="0px"
      viewBox="0 0 200 175"
      style={style}
      fill={color ? color : "#C7C7C7"}
    >
      <g>
        <path d="M95.9,69.96c-0.72-1.13-1.11-2.47-1.11-3.9c0-5.5,5.89-9.6,11.71-6.35c1.02,0.57,1.84,1.43,2.35,2.48   c1.39,2.82,1.17,5.66-0.17,7.78c2.53,0.7,4.89,1.76,6.99,3.2c0.96,0.86,1.91,0.41,1.91,0.41s9.01-4.66,8.82-15.01   c-0.17-8.68-9.24-13.74-12.15-15.15c-0.38-0.18-0.8,0.14-0.74,0.55c0.18,1.32,0.45,3.75,0.23,5.76c-0.09,0.85-1.01,1.34-1.79,0.97   c-5.61-2.64-24.75-8.07-37.94,6.64c-1.01,1.04,0.25,0.96,0.25,0.96h4.68c0.63,0,1.1,0.56,0.98,1.17   c-0.73,3.54-4.34,14.42-21.65,23.21c-0.52,0.27-0.7,0.97-0.32,1.42c3.16,3.63,7.37,5.1,10.55,5.67c2.55,0.46,5.18,0.14,7.61-0.76   l1.33-0.49c0.82-0.31,1.41-1,1.65-1.85C81.37,78.56,87.77,72.19,95.9,69.96z" />
        <path d="M84.72,86.35l13.97-4.52c2.34-0.76,4.86-0.76,7.2,0l13.97,4.52c0.38,0.12,0.75-0.27,0.6-0.64   c-2.94-7.14-9.97-12.16-18.17-12.16c-8.18,0-15.21,5.02-18.17,12.15C83.97,86.08,84.34,86.47,84.72,86.35z" />
        <circle cx="102.29" cy="66.06" r="4.19" />
        <path d="M126.92,126.52l-5.42-14.75c-0.18-0.48-0.35-1.01-0.38-1.18c-0.04-0.17,0.14-1.04,0.27-1.53l3.63-13.76   c0.13-0.49,0.18-1.27,0.11-1.72c-0.07-0.46-1.34-1.17-1.83-1.31l-15.23-4.32c-0.49-0.14-1.28-0.3-1.7-0.14   c-0.53,0.2-1.2,1.29-1.35,1.78l-0.97,3.06c-0.15,0.48-0.64,1.09-1.08,1.34c0,0-0.4,0.25-0.66,0.25S101.64,94,101.64,94   c-0.44-0.25-0.93-0.86-1.08-1.34l-0.97-3.06c-0.15-0.48-0.44-1.25-0.82-1.5c-0.51-0.34-1.75-0.28-2.24-0.14L81.3,92.27   c-0.49,0.14-1.18,0.49-1.54,0.79c-0.36,0.3-0.32,1.75-0.19,2.24l3.66,13.76c0.13,0.49,0.25,1.04,0.27,1.22   c0.02,0.18-0.24,1.01-0.41,1.49l-5.39,14.75c-0.17,0.48-0.32,1.19-0.32,1.58c0,0.39,0.97,1.33,1.4,1.61L96.44,141   c0.43,0.27,1.19,0.5,1.7,0.51c0,0,0.26,0.04,0.5-0.08s0.34-0.32,0.34-0.32c0.32-0.4,0.62-1.14,0.69-1.64l2.06-16.77   c0.06-0.5,0.11-0.94,0.11-0.97c0-0.01,0.01-0.08,0.02-0.19c-0.01,0.16-0.01,0.26-0.01,0.23c0-0.24,0.19-0.43,0.43-0.43   c0.24,0,0.43,0.19,0.43,0.43c0,0.03,0-0.04-0.01-0.16c0,0.01,0.01,0.04,0.01,0.04c0.01,0.04,0.07,0.54,0.13,1.05l2.03,16.77   c0.06,0.5,0.37,1.24,0.69,1.63c0,0,0.13,0.2,0.35,0.32s0.49,0.08,0.49,0.08c0.51-0.01,1.27-0.24,1.7-0.51l17.73-11.29   c0.43-0.27,0.97-0.76,1.2-1.08C127.27,128.3,127.09,127,126.92,126.52z M88.41,127.63c-0.12,0.49-0.59,0.72-1.05,0.5l-1.69-0.8   c-0.46-0.22-1.08-0.66-1.37-0.98c-0.3-0.32-0.14-1.7,0.03-2.17l1.77-5.03c0.17-0.48,0.71-0.79,1.21-0.69l2.2,0.45   c0.5,0.1,0.81,0.59,0.69,1.08L88.41,127.63z M95.58,131.27c-0.08,0.5-0.54,0.76-1.02,0.58l-1.27-0.48   c-0.47-0.18-1.11-0.56-1.42-0.85c-0.3-0.29-0.3-1.64-0.2-2.14l1.57-7.38c0.11-0.5,0.59-0.78,1.07-0.62l2.05,0.65   c0.48,0.15,0.81,0.69,0.73,1.19L95.58,131.27z M103.69,112.34c-0.48,0.18-1.03,0.35-1.23,0.38c-0.2,0.04-1.11-0.21-1.58-0.38   l-12.83-4.71c-0.48-0.17-1.06-0.46-1.29-0.63c-0.23-0.17-0.64-1.24-0.74-1.74l-0.28-1.35c-0.1-0.5-0.03-1.29,0.15-1.76l0.75-0.67   c0.49-0.13,1.29-0.1,1.77,0.06l12.49,4.2c0.48,0.16,1.03,0.32,1.22,0.34c0.19,0.03,1.03-0.18,1.51-0.34l12.52-4.2   c0.48-0.16,1.28-0.18,1.77-0.05l0.76,0.65c0.19,0.47,0.26,1.27,0.15,1.76l-0.28,1.38c-0.1,0.5-0.3,1.11-0.43,1.36   c-0.13,0.25-1.12,0.79-1.6,0.97L103.69,112.34z M112.7,130.52c-0.3,0.29-0.94,0.67-1.42,0.85l-1.3,0.49   c-0.48,0.18-0.93-0.08-1.01-0.59l-1.49-9.06c-0.08-0.5,0.25-1.04,0.73-1.19l2.05-0.65c0.48-0.15,0.97,0.13,1.07,0.62l1.57,7.38   C113.01,128.87,113.01,130.23,112.7,130.52z M120.29,126.35c-0.29,0.32-0.9,0.76-1.36,0.98l-1.72,0.81   c-0.46,0.22-0.93-0.01-1.05-0.51l-1.79-7.65c-0.12-0.49,0.2-0.98,0.69-1.08l2.2-0.45c0.5-0.1,1.04,0.21,1.21,0.69l1.77,5.03   C120.42,124.65,120.58,126.02,120.29,126.35z" />
      </g>
    </svg>
  );
}

export const HeadHeroAdd: FC<BaseSvgProps> = ({ className, style, color }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="22.369"
      height="22.37"
      viewBox="0 0 22.369 22.37"
      fill={color ? color : "#a28847"}
      style={style}
    >
      <g transform="translate(-925.5 -958.223)">
        <g transform="translate(928.315 960.985)">
          <rect
            width="16.846"
            height="2.83"
            rx="1.415"
            transform="translate(0 7.008)"
          />
          <rect
            width="16.847"
            height="2.83"
            rx="1.415"
            transform="translate(7.008 16.847) rotate(-90)"
          />
        </g>
        <rect
          width="21.369"
          height="21.37"
          stroke="#a28847"
          rx="4.37"
          transform="translate(926 958.723)"
          fill="none"
          stroke-miterlimit="10"
          strokeWidth="1"
        />
      </g>
    </svg>
  );
};

export const HeadHeroPre: FC<BaseSvgProps> = ({ className, style, color }) => {
  return (
    <svg
      className={className}
      style={{
        ...style,
        ...{
          position: "relative",
          right: "5%",
        },
      }}
      xmlns="http://www.w3.org/2000/svg"
      width="47.018"
      height="66.505"
      viewBox="0 0 47.018 66.505"
      fill={color ? color : "#a28847"}
    >
      <g transform="translate(-498.297 -98.116)">
        <path
          d="M1772.191,170.735a4.915,4.915,0,0,1-.754-2.644,5.155,5.155,0,0,1,7.934-4.3,3.9,3.9,0,0,1,1.592,1.678,5.307,5.307,0,0,1-.113,5.269,15.736,15.736,0,0,1,4.733,2.165,1.207,1.207,0,0,0,1.3.274s6.105-3.155,5.978-10.167c-.118-5.883-6.259-9.311-8.234-10.263a.356.356,0,0,0-.5.373,17.537,17.537,0,0,1,.157,3.9.847.847,0,0,1-1.211.659c-3.8-1.788-16.764-5.467-25.705,4.5-.681.7.173.651.173.651h3.17a.664.664,0,0,1,.662.795c-.5,2.4-2.937,9.77-14.664,15.726a.633.633,0,0,0-.216.959,12.244,12.244,0,0,0,7.148,3.844,9.818,9.818,0,0,0,5.157-.517l.9-.335a1.841,1.841,0,0,0,1.118-1.252A16.33,16.33,0,0,1,1772.191,170.735Z"
          transform="translate(-1248.048 -54.594)"
        />
        <path
          d="M1800.956,223.518l9.462-3.061a7.927,7.927,0,0,1,4.879,0l9.464,3.062a.33.33,0,0,0,.406-.43,13.316,13.316,0,0,0-24.618,0A.33.33,0,0,0,1800.956,223.518Z"
          transform="translate(-1284.386 -96.271)"
        />
        <circle
          cx="2.841"
          cy="2.841"
          r="2.841"
          transform="translate(525.635 110.656)"
        />
        <path
          d="M1820.292,270.308l-3.674-10c-.119-.323-.236-.682-.261-.8a4.951,4.951,0,0,1,.182-1.035l2.462-9.32a3.417,3.417,0,0,0,.071-1.168c-.049-.31-.911-.794-1.242-.888l-10.319-2.926a2.309,2.309,0,0,0-1.154-.094,2.437,2.437,0,0,0-.918,1.2l-.658,2.074a1.876,1.876,0,0,1-.731.91,1.162,1.162,0,0,1-.445.17,1.112,1.112,0,0,1-.437-.17,1.872,1.872,0,0,1-.731-.91l-.659-2.074a2.191,2.191,0,0,0-.554-1.016,2.446,2.446,0,0,0-1.518-.094l-10.319,2.926a3.425,3.425,0,0,0-1.044.535c-.243.2-.214,1.188-.126,1.521l2.482,9.32a7.85,7.85,0,0,1,.183.825,4.963,4.963,0,0,1-.281,1.007l-3.654,9.994a3.819,3.819,0,0,0-.215,1.073c0,.267.657.9.947,1.087l11.969,7.649a2.6,2.6,0,0,0,1.153.346.621.621,0,0,0,.342-.054.551.551,0,0,0,.233-.215,2.636,2.636,0,0,0,.465-1.111l1.393-11.362c.042-.342.076-.636.076-.654s.005-.057.014-.126c-.006.108-.01.178-.01.154a.292.292,0,1,1,.584,0,.9.9,0,0,1-.007-.11s0,.025,0,.027c.006.024.045.368.086.709l1.373,11.362a2.558,2.558,0,0,0,.469,1.107.783.783,0,0,0,.236.22.584.584,0,0,0,.333.054,2.6,2.6,0,0,0,1.153-.345l12.013-7.65a3.526,3.526,0,0,0,.815-.733A2.559,2.559,0,0,0,1820.292,270.308Zm-26.087.751a.484.484,0,0,1-.708.341l-1.143-.544a3.611,3.611,0,0,1-.929-.666c-.2-.219-.094-1.149.02-1.473l1.2-3.411a.741.741,0,0,1,.82-.466l1.489.3a.6.6,0,0,1,.471.734Zm4.861,2.464a.494.494,0,0,1-.688.395l-.861-.328a3.483,3.483,0,0,1-.961-.576,2.491,2.491,0,0,1-.135-1.451l1.064-5a.558.558,0,0,1,.727-.423l1.39.439a.744.744,0,0,1,.493.806Zm5.495-12.821a7.236,7.236,0,0,1-.83.259,4.227,4.227,0,0,1-1.073-.259l-8.693-3.189a4.506,4.506,0,0,1-.874-.425,3.239,3.239,0,0,1-.5-1.176L1792.4,255a2.475,2.475,0,0,1,.1-1.195l.511-.452a2.474,2.474,0,0,1,1.2.042l8.46,2.846a7,7,0,0,0,.825.233,4.476,4.476,0,0,0,1.024-.232L1813,253.39a2.414,2.414,0,0,1,1.2-.033l.514.444a2.49,2.49,0,0,1,.1,1.2l-.191.937a4.308,4.308,0,0,1-.291.922,3.259,3.259,0,0,1-1.084.657Zm6.1,12.313a3.444,3.444,0,0,1-.961.573l-.882.332a.494.494,0,0,1-.687-.4l-1.011-6.138a.746.746,0,0,1,.495-.806l1.39-.439a.558.558,0,0,1,.727.423l1.064,5A2.488,2.488,0,0,1,1810.662,273.014Zm5.143-2.826a3.392,3.392,0,0,1-.919.664l-1.164.548a.486.486,0,0,1-.709-.343l-1.215-5.183a.605.605,0,0,1,.471-.734l1.489-.3a.741.741,0,0,1,.82.466l1.2,3.411C1815.889,269.04,1816,269.97,1815.805,270.189Z"
          transform="translate(-1275.135 -115.847)"
        />
      </g>
    </svg>
  );
};

export default HeroPre;
